import type { PatientCardInfoState, RootState } from "@/lib/types/state";

/**
 * Selects the entire patient card info state.
 *
 * @param state - The root Redux state
 * @returns The patient card info state object
 */
export const selectPatientCardInfo = (state: RootState): PatientCardInfoState => {
  return state?.patientCardInfo;
};
